import Link from 'next/link';
import { AnchorHTMLAttributes } from 'react';
import { getNewsPrefix } from '@/news-translations';
import { useSettingsPrefetch } from '@/settings/SettingsContext';

export const NextLink = (
  {
    scroll,
    href,
    children,
    ...props
  }: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string, scroll?: boolean },
) => {
  const prefetch = useSettingsPrefetch();
  return href.startsWith(`/${getNewsPrefix()}`)
    ? <a href={href} {...props}>{children}</a>
    : <Link scroll={!!scroll} href={href} passHref prefetch={prefetch} {...props}>{children}</Link>;
};
